export default __webpack_public_path__ + "static/er-8403fc80f42d3e63955eaccf7d1eae7f.svg";